<template>
    <div class="roothome">

        <div class="wrapper">
            <!-- Sidebar Holder -->
            <nav id="sidebar">
                <div id="dismiss">
                    <!--<img src="/static/imgs/ic_menu.png" alt="menu" class="im_menu1">-->
                </div>

                <div class="sidebar-header" style="font-size: 1.1em; display: flex; align-items: center; height: 40vh;">

                    <div style="width: 100%; text-align: center;">
                        <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="width: 70%; max-height: 10vh; margin-top: 5vh; margin-bottom: 2.5vh; object-fit: contain">
                        <!--<img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="width: 70%; margin-top: 5vh; margin-bottom: 2.5vh;">-->
                    </div>

                    <!--<div style="margin-bottom: 2.5vh">-->
                        <!--<span class="tx_idioma" v-if="user.idioma==0" style="font-family: 'Humanst521BT';">Português</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma!=0" @click="changeIdioma(0)">Português</span>-->
                        <!--<span class="tx_idioma">&#149;</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma==1" style="font-family: 'Humanst521BT';">English</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma!=1" @click="changeIdioma(1)">English</span>-->
                        <!--<span class="tx_idioma">&#149;</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma==2" style="font-family: 'Humanst521BT';">Español</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma!=2" @click="changeIdioma(2)">Español</span>-->
                    <!--</div>-->

                    <div v-if="user.sucess" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <span style="font-size: 2.5vh;">{{ getInterText(inter_ind.ola) }} {{ getFirstAndLastWords(user.nome) }}</span>

                        <div class="div_botao_t" @click="logout()" onMouseOver="this.style.cursor='pointer'">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.sair) }} </span>
                        </div>
                    </div>
                    <div v-else style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <router-link to="registerUser" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                            <div class="div_botao_t_w">
                                <span class="tx_continuar"> {{ getInterText(inter_ind.cadastre) }} </span>
                            </div>
                        </router-link>

                        <div class="div_botao_t" @click="setShowLogin(true)">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.entrar) }} </span>
                        </div>
                    </div>


                    <div class="custom-select-filtro">
                        <select class=".selectCity" id="sel_cats" @change="changeCity($event)" v-model="cityIndex" >
                            <option value="0" v-if="city_full.length > 0"> {{ city_full[0].nome }} </option>
                            <option v-for="(item, index) in city_full" :value="index" v-if="index > 0"> {{ item.nome }} ({{ item.quant }}) </option>
                        </select>
                        <img src="/static/imgs/ic_down.png" style="width: 5%; margin-right: 3%; object-fit: contain;">
                    </div>


                </div>

                <div style="display: flex; flex-direction: column; height: 57vh;">
                <ul class="list-unstyled components noScrollMenu" style="margin-top: 0; overflow-y: scroll; font-size: 1.2vw; height: max-content; flex-grow: 90; flex-shrink: 0;">
                    <li class="active">
                        <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.categorias) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu" >
                            <!--<li v-for="item in cats_full" @click="atualizaEstabs(item.id, true)">-->
                            <li v-for="(item, index) in cats_full" v-if="index > 0">
                                <div class="lineMenu" @click="goToHomeDesk(item.id)">
                                    <img onerror="tryReloadImages(this)" v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min">
                                    <span style="font-size: 2.2vh;">{{ getInterCatName(item) }}</span>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="/Visao" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.quem_somos) }}</a>
                    </li>

                    <li class="active">
                        <a style="font-family: 'Humanst521BT';" href="#pageSubmenu3" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu3">{{ getInterText(inter_ind.nossas_redes) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu3" >
                            <li>
                                <a href="https://www.facebook.com/adviceparaiba" target="_blank">
                                    <img src="/static/imgs/ic_facebookmenu.png" class="im_cat_min_2">
                                    <span>Facebook</span>
                                </a>
                                <a href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg" target="_blank">
                                    <img src="/static/imgs/ic_youtubemenu.png" class="im_cat_min_2">
                                    <span>YouTube</span>
                                </a>
                                <a href="https://www.instagram.com/adviceparaiba/" target="_blank">
                                    <img src="/static/imgs/ic_instagrammenu.png" class="im_cat_min_2">
                                    <span>Instagram</span>
                                </a>
                                <a href="https://twitter.com/AdviceParaiba" target="_blank">
                                    <img src="/static/imgs/ic_twittermenu.png" class="im_cat_min_2">
                                    <span>Twitter</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <!--<li @click="changeShow10Mais()">-->
                    <li @click="changeShow10Mais()" style="cursor: pointer;">
                        <a style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.os) }} 10+</a>
                    </li>
                    <li>
                        <a href="/Contato" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.contato) }}</a>
                    </li>
                    <li>
                        <a href="/ExpedicaoAdvice" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.expedicao) }}</a>
                    </li>
                    <li class="active">
                        <a style="font-family: 'Humanst521BT';" href="#pageSubmenu2" data-toggle="collapse"x aria-expanded="false" aria-controls="pageSubmenu2">{{ getInterText(inter_ind.telefones_uteis) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu2">
                            <li v-for="item in telefoneUteis">
                                <a :href="'tel:' + trimAll(item.tel)" style="margin-left: 5px">{{ getInterText(item.nome) }}: {{ item.tel }}</a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <!-- PARCEIROS -->
                <!--<div class="div_pat_m">-->
                    <!--<hr class="hr_pat"/>-->
                    <!--<div style="display: flex;">-->
                        <!--<a v-for="item in barra_pat" :href="item.url" target="_blank"><img :src="item.imgPathW" class="im_pat_m"/></a>-->
                    <!--</div>-->
                <!--</div>-->
                </div>
            </nav>

            <div v-if="!show10Mais" class="section_desk" id="sidebarCollapse" @click="changeSideBar()">
                <a class="navicon-button x" id="icmenu" >
                    <div class="navicon">
                    </div>
                </a>
            </div>



        <div style="background-color: var(--main-bg-color-new); height: auto; display: flex; justify-content: center;">

            <!-- ################    Top Menu Bar    ################# -->
            <div align="center" class="head0">
                <div class="head1" style="justify-content: flex-start;">
                        <img v-if="modoMosaico" src="/static/imgs/ic_back_b.png" alt="menu" class="im_menu2" style="padding-left: 10%;" @click="atualizaEstabsToggle(cat.id)" onMouseOver="this.style.cursor='pointer'">
                        <!--<div class="bar_cidades">-->
                            <!--<span v-if="city_full[cityIndex] != null" style="font-size: 2vh; color: black"> {{ city_full[cityIndex].nome }} </span>-->
                            <!--<select @change="changeCity($event)" v-model="cityIndex" style="border:0px; outline:0px; border: none; scroll-behavior: smooth; background-color: white; -webkit-appearance:none; font-size: 2vh; position: absolute; opacity: 0; width: 26vh;">-->
                                <!--<option value="0" v-if="city_full.length > 0"> {{ city_full[0].nome }} </option>-->
                                <!--<option v-for="(item, index) in city_full" :value="index" v-if="index > 0"> {{ item.nome }} ({{ item.quant }}) </option>-->
                            <!--</select>-->
                        <!--</div>-->
                        <img src="/static/imgs/advicep_horizontal.png" @click="clearCategorias()" alt="logo advice" class="im40_2" style="cursor: pointer;">
                </div>

                <div  class="head3" style="width: 70%; margin-left: 3%;">
                    <!--<div style="display: flex; height: 35%; width: 100%; align-items: center; justify-content: center;">-->
                        <!--<div class="bar_idiomas">-->
                            <!--<img v-if="user.idioma==0" src="/static/imgs/ic_b_pt.jpg" alt="barra idiomas" style="height: 70%;">-->
                            <!--<img v-if="user.idioma==1" src="/static/imgs/ic_b_en.jpg" alt="barra idiomas" style="height: 70%;">-->
                            <!--<img v-if="user.idioma==2" src="/static/imgs/ic_b_es.jpg" alt="barra idiomas" style="height: 70%;">-->
                            <!--<span style="font-size: 2vh; color: black; margin-right: 7%;"> {{ getIdioma(user.idioma) }} </span>-->
                            <!--<select @change="changeIdiomaSelector($event)" v-model="user.idioma" style="border:0px; outline:0px; border: none; scroll-behavior: smooth; background-color: white; -webkit-appearance:none; font-size: 2vh; position: absolute; opacity: 0; width: 100%;">-->
                                <!--<option value="0"> Português&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                <!--<option value="1"> English&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                <!--<option value="2"> Español&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                            <!--</select>-->
                        <!--</div>-->
                    <!--</div>-->
                    <span class="tx_title_guia">{{getInterText(inter_ind.seu_guia_turistico)}}</span>


                    <!--<br>-->
                    <!--<div style="display: flex; height: 40%; margin-left: 10%; margin-right: 10%;">-->
                        <!--<a target="_blank" href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg"><img src="/static/imgs/ic_youtube2.png" alt="youtube" class="im_social"></a>-->
                        <!--<a target="_blank" href="https://www.facebook.com/adviceparaiba/"><img src="/static/imgs/ic_face2.png" alt="facebook" class="im_social"></a>-->
                        <!--<a target="_blank" href="https://www.instagram.com/adviceparaiba/"><img src="/static/imgs/ic_instagram2.png" alt="instagram" class="im_social"></a>-->
                        <!--<a target="_blank" href="https://twitter.com/AdviceParaiba"><img src="/static/imgs/ic_twitter2.png" alt="twitter" class="im_social"></a>-->
                    <!--</div>-->
                </div>
                <div  class="head4">
                    <div v-if="!user.sucess" style="display: flex; flex-direction: row; align-items: center; height: 100%;">
                        <div style="display: flex; height: 100%; min-height: 100%; align-items: flex-end;">
                            <div class="im_id_container">
                                <img class="im_id" v-if="user.idioma==0" src="/static/imgs/ic_pt2.png"/>
                                <img class="im_id" v-if="user.idioma!=0" src="/static/imgs/ic_pt1.png" @click="changeIdioma(0)"/>
                                <img class="im_id" v-if="user.idioma==1" src="/static/imgs/ic_en2.png"/>
                                <img class="im_id" v-if="user.idioma!=1" src="/static/imgs/ic_en1.png" @click="changeIdioma(1)"/>
                                <img class="im_id" v-if="user.idioma==2" src="/static/imgs/ic_es2.png"/>
                                <img class="im_id" v-if="user.idioma!=2" src="/static/imgs/ic_es1.png" @click="changeIdioma(2)"/>
                            </div>
                                <a href="/registerUser" >
                                    <span class="tx_login2" >{{ getInterText(inter_ind.cadastre) }} </span>
                                </a>
                            </div>

                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <img @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'" src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile" style="height: 25%; margin-right: 0; margin-left: 0; margin-bottom: -15%;">

                            <span class="tx_login" style="margin-bottom: 0; margin-top: 7%; color: var(--gray-menu)" @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.entrar) }}</span>
                        </div>
                    </div>
                    <div v-else @click="showPopEscritorio()" style="cursor: pointer;">
                        <div class="im_id_container" style=" margin-right: 130px">                                <img class="im_id" v-if="user.idioma==0" src="/static/imgs/ic_pt2.png"/>
                            <img class="im_id" v-if="user.idioma!=0" src="/static/imgs/ic_pt1.png" @click="changeIdioma(0)"/>
                            <img class="im_id" v-if="user.idioma==1" src="/static/imgs/ic_en2.png"/>
                            <img class="im_id" v-if="user.idioma!=1" src="/static/imgs/ic_en1.png" @click="changeIdioma(1)"/>
                            <img class="im_id" v-if="user.idioma==2" src="/static/imgs/ic_es2.png"/>
                            <img class="im_id" v-if="user.idioma!=2" src="/static/imgs/ic_es1.png" @click="changeIdioma(2)"/>
                        </div>
                        <div v-if='user.foto === ""' class="im_profile" style="text-align: center; padding-top: 1.2vh; background-color: var(--bg-blue)">
                            <span class="tx_initials" >{{ getInitials(user) }}</span>
                        </div>
                        <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile">
                        <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto' alt="profile" class="im_profile">
                        <br>
                        <span class="tx_login5" >{{ getFirstAndLastWords(user.nome) }}</span>
                        <div style="width: 100%; display: flex; justify-content: center;">
                            <div class="triangle"></div>
                        </div>
                    </div>
                    <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                        <div class="arrow_top"></div>

                        <div style="display: flex; flex-direction: column; height: 15vh; justify-content: space-evenly;">
                            <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'MinhaPagina'}">
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.minha_conta) }}</span>
                            </router-link>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('EditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                        </div>
                    </div>
                </div>




            </div>

            <!-- ################    panorama     ################# -->
            <!--<div class="title2">-->
                <!--<div class="title2_2">-->
                    <!--&lt;!&ndash;<img src="/static/imgs/panoramica02.jpg" alt="panoramica" class="im100_search">&ndash;&gt;-->
                    <!--<img :src="pano[panoInd].imgPath" alt="panoramica" class="im100_search" :style="'top: -'+ pano[panoInd].shift +'px;'">-->
                <!--</div>-->
            <!--</div>-->

            <div class="title4">

            <!-- ################    Title    ################# -->
            <!--<div class="title0" style="background-color: red">-->
                <!--<div class="title3_v2" v-if="getEstabs(cat.id).length!=0 || cat.id==-1">-->
                    <!--<img v-if="cat.id>=0" :src="baseUrlImg + 'CATEGORIA/' + cat.imgPath2" alt="categorias" class="im_categoria2"/>-->
                    <!--<img v-if="cat.id==-1"  src="/static/imgs/ic_lupa.png" alt="categorias" class="im_categoria2"/>-->
                    <!--<span style="flex-grow: 1; color: var(&#45;&#45;bg-blue)" >{{ cat.nome }} </span>-->
                <!--</div>-->
            <!--</div>-->


            <!-- ################    Estabelecimento    ################# -->
            <div class="back01" >

                <div class="bodyp1">
                    <div class="bodysubp12" >

                        <div class="bodysubp1">
                            <div class="divF1">
                                <img v-if="estab.id === -1" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="Foto1 Estab" class="imF1 animated-background">
                                <img onerror="tryReloadImages(this)" v-else-if="estab.tbFotos!=null" @click="showGalery(true)" :src="baseUrlImg + 'MARCADOR/' + estab.tbFotos[getPhotoIndex(0)].file" alt="Foto1 Estab" class="imF1"><br>
                                <!--<img v-if="estab.tbFotos!=null" :src="baseUrlImg + 'MARCADOR/' + estab.tbFotos[getPhotoIndex(0)].file" alt="Foto1 Estab" class="imF1"><br>-->

                                <div class="div_arrow_l">
                                    <img src="/static/imgs/ic_left_2.png" onmouseover="this.src='/static/imgs/ic_left.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_left_2.png'" alt="Foto Anterior" @click="nextPhoto(-1)" class="im_arrow" >
                                </div>
                                <div class="div_arrow_r">
                                    <img src="/static/imgs/ic_right_2.png" onmouseover="this.src='/static/imgs/ic_right.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_right_2.png'" alt="Foto Anterior" @click="nextPhoto(1)" class="im_arrow">
                                </div>
                            </div>
                        </div>

                        <div class="bodysubp2">
                            <div class="divF2">
                                <img v-if="estab.id === -1" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="Foto2 Estab" class="imF2 animated-background">
                                <img onerror="tryReloadImages(this)" v-else-if="estab.tbFotos!=null" @click="nextPhoto(1)" :src="baseUrlImg + 'MARCADOR/' + estab.tbFotos[getPhotoIndex(1)].file" alt="Foto2 Estab" class="imF2">
                            </div>

                            <div class="divF3">
                                <img v-if="estab.id === -1" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="Foto3 Estab" class="imF2 animated-background">
                                <img onerror="tryReloadImages(this)" v-else-if="estab.tbFotos!=null" @click="nextPhoto(2)" :src="baseUrlImg + 'MARCADOR/' + estab.tbFotos[getPhotoIndex(2)].file" alt="Foto3 Estab" class="imF2">
                            </div>
                        </div>

                    </div>




                    <div class="bodysubp3">
                        <!-- ################  Titulo Estab, avaliaçao, ticket    ################# -->
                        <div style="display: flex; flex-direction: row;">
                            <div style="width: 60%;">
                                <div style="display: flex; align-items: center; margin-top: 1vh;">
                                    <span class="tx_title_estab" v-html="decodeChars(estab.nome)"></span>
                                    
                                </div>

                                <div style="display: flex; align-items: center;">
                                    <span class="txt" style="overflow: hidden; white-space:nowrap; text-overflow: ellipsis; width: 45vw;">
                                        {{ getCatsStr(estab) }}
                                    </span>
                                </div>

                                <div class="di_stab_buttons" style="">
                                    <div style="display: flex; flex-direction: row; align-items: center;">
                                        <div class="di_star_wrap" style="with: 6vw; max-width: 6vw; height: 1.1vw;" :title="getInterText(inter_ind.avaliacao) + ((estab.avaliacao * 100)/5.0)">
                                            <div alt="estrelas" class="im_star" :style="'width: ' + ((estab.avaliacao * 100)/5.0) + '%; height: 1.1vw;'" align="right"/>
                                        </div>
                                    </div>

                                    <div class="di_star_popup" style="margin-left: 0;" v-if="showAvaliacao" id="popup_avaliacao">
                                        <span v-if="estab.avaliacao <= 0" style="font-size: 4vh;">Avalie</span>
                                        <span v-else style="font-size: 4vh;">{{ getInterText(inter_ind.sua_avaliacao) }}</span>
                                        <div style="display: flex; justify-content: center; margin-top: -1.5vh;">
                                            <div v-for="i in 5" onMouseOver="this.style.cursor='pointer'" @click="changeAvaliacao(i)">
                                                <img v-if="avaliacao < i" class="im_star_single" src="/static/imgs/ic_estrela_empty_single.png"/>
                                                <img v-else class="im_star_single" src="/static/imgs/ic_estrela_filled_single.png" />
                                            </div>
                                        </div>
                                        <img v-if="loading.avaliacao" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up" style="width: 5vh; height: 5vh;">
                                        <div class="button_white_a" style="margin: 0; width: 45%;" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(estab.id, avaliacao)">
                                            <span style="font-size: 3vh;">{{ getInterText(inter_ind.enviar) }}</span>
                                        </div>
                                    </div>
                                    <!--<img src="/static/imgs/ic_back_pink.png" style="display: flex; width: 8%; height: 1.8vh; align-self: stretch; object-fit: contain; margin-left: 2vw;" onMouseOver="this.style.cursor='pointer'" @click="exibeAvaliacao(estab.id)">-->
                                    <div class="button_white_a2" onMouseOver="this.style.cursor='pointer'" @click.prevent.stop="exibeAvaliacao(estab.id)" style="display: flex; margin-left: 0.4vw; margin-top: 0; align-self: stretch; height: 2.3vh; align-items: center; padding-left: 0; padding: 0; width: 7vw; background: none; border: none;">
                                        <img :src="getAvalieNosImage()" alt="Avalie-nos" class="avalie-nos-button">
                                    </div>



                                </div>
                            </div>

                            <div style="width: 39%;">
                                <div style="display: flex; flex-grow: 1; justify-content: flex-end;">
                                    <div onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(estab.id, -1)">
                                        <img v-if="isFavorite(estab.id)" src="/static/imgs/ic_favoritos.png" alt="favoritos" class="im_fav_m" :title="getInterText(inter_ind.favoritos)"/>
                                        <img v-else src="/static/imgs/ic_favoritos_not.png" alt="favoritos" class="im_fav_m" :title="getInterText(inter_ind.favoritos)"/>
                                        <img v-if="loading.favorito" src="/static/imgs/loading5.gif" alt="Carregando" class="im_fav_m">
                                    </div>
                                    <img @click="share" src="/static/imgs/ic_share.png" alt="Share" :class="{'active-share': showShare, 'im_share': true}"/>
                                </div>
                                <!-- ########### Ticket Médio (CIFRAO) ###########-->
                                <div v-if="hasSubCatsTicket(estab)" class="di_stab_buttons_m" style="width: 48%;">
                                    <div style="display: flex; justify-content: center;">
                                        <span style="font-size: 1.7vh; text-align: center;">{{ getInterText(inter_ind.ticket_medio) }}</span>
                                    </div>

                                    <div style="display: flex; justify-content: center; width: 8vw; height: 1.48148vw; font-size: 0; border-width: 0; border: none;">
                                        <div class="di_cifrao_wrap_estab" :title="((getInvestimento(estab) * 100)/5.0)">
                                            <div alt="cifroes" class="im_cifrao" :style="'max-width: ' + ((getInvestimento(estab) * 100)/5.0) + '%;'"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- AddToAny BEGIN -->
                        <div v-if="showShare" style="text-align: right;">
                            <a :href="getShareLink2(1, estab)" target="_blank"><img src="/static/imgs/ic_share_whats_3d.png" class="small-share-img"></a>
                            <a :href="getShareLink2(2, estab)" target="_blank"><img src="/static/imgs/ic_share_face_3d.png" class="small-share-img"></a>
                            <img @click="goShare(7)" src="/static/imgs/ic_share_link_3d.png"  class="small-share-img">
                        </div>
                        <!-- AddToAny END -->


                        <!-- ################  Descricao e Comentarios    ################# -->
                        <div style="background-color: #fff; padding: 2%; margin-top: 1vw; color: var(--font-dark-gray);">

                            <div v-if="loading.desc" style="display: flex; width: 100%; align-items: center; flex-direction: column;">
                                <img src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">
                            </div>

                            <span class="txt" v-if="renderDescription" v-html="estab.descricao_trans"></span><br>

                            <div style="width: 100%; text-align: center;">
                                <iframe v-if="isYouTubeLink(estab.video_link)" width="50%" height="300" :src="'https://www.youtube.com/embed/' + getYoutubeCode(estab.video_link)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                            </div>

                            <div v-if="estab.site2" style="width: 100%; text-align: right;">
                                <a target="_blank" :href="decodeChars2(estab.site2)">
                                    <img :src="getReserveImage()" alt="Reservar" class="bt_anun reserve-button">
                                </a>
                            </div>

                            <!-- ################   Comentarios    ################# -->
                            <div class="bodysubp4" style="margin-top: 7vh">
                                <h3>{{ getInterText(inter_ind.comentarios) }} ({{ commentaries.length }})</h3>

                                <div class="title2_coment">
                                    <div v-if="user.sucess" style="display: inline-block;">
                                        <img v-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im1" style="vertical-align: top; margin-right: 10px;">
                                        <img v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im1" style="vertical-align: top; margin-right: 10px;">
                                    </div>
                                    <img v-else src="/static/imgs/ic_profile2.png" alt="profile" class="im1" style="vertical-align: top;">

                                    <textarea type="text" class="search" :placeholder="getInterText(inter_ind.comentario_escreva) + '...'" v-model="commentTx"></textarea>
                                </div>
                                <div style="display: flex; justify-content: flex-end;">
                                    <div style="background-color: var(--bg-purple); border-radius: 100px;" onMouseOver="this.style.cursor='pointer'" @click="addCommentary(0, -1)">
                                        <span style="color: white; padding-right: 2.5vh; padding-left: 2.5vh; font-size: 2.5vh;">{{ getInterText(inter_ind.enviar) }} </span>
                                    </div>
                                </div>
                                <hr style="margin-left: 70px;">

                                <div v-for="(item, index) in commentaries" style="display: flex; flex-direction: column; width: 100%; position: relative; font-size: 2vh;" :key="item.id">
                                    <div style="display: flex; align-items: flex-start; margin-bottom: 2vw">
                                        <div style="display: inline-block; text-align: start; width: 12%;">
                                            <img v-if='hasHttp(item.userPhoto)'  :src='unscapePath(item.userPhoto)' alt="profile" class="im1" :title="item.userName">
                                            <img v-else :src='baseUrlImg + "PROFILE/" + item.userPhoto'          alt="profile" class="im1" :title="item.userName">
                                        </div>
                                        <div style="display: flex; flex-direction: column; width: 74%; align-self: flex-start;">
                                            <div style="display: inline-block; position: relative; vertical-align: top; text-align: justify;">
                                                <span style="color: darkblue">{{ getFirstAndLastWords(item.userName) }}</span>
                                                <span>{{ calcBehindTime(item.data) }}</span>
                                                <img v-if="user.sucess && item.idUsuario == user.id" src="/static/imgs/bt_erase.png" alt="profile" class="im_del_comment" @click="rmCommentary(item.id)">
                                            </div>
                                            <!--<div class="translate" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">-->
                                            <div v-if="renderCommentaries" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">
                                                <!--<div id="trans_area" class="translate_control" style="font-weight: bold; background-color: purple; display: none;">-->
                                                <!--</div>-->
                                                {{ item.tx_trans }}
                                            </div>
                                            <!--<div style="display: inline-block; position: relative; vertical-align: top; text-align: justify;">-->
                                            <div style="display: flex; flex-direction: column; position: relative; vertical-align: top; text-align: justify;">
                                                <span @click="setShowResponder(index)" style="cursor: pointer; font-weight: bold; font-size: 1.5vh;">{{ getInterText(inter_ind.responder) }} </span>
                                                <div v-if="showRespComments != index" style="color: #acadaf; margin-top: 1vw; margin-bottom: 1vw;">
                                                    <span v-if="item.resps != undefined && item.resps.length == 1" @click="setShowRespComments(index)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.ver) }} {{ item.resps.length }} {{ getInterText(inter_ind.resposta) }}</span>
                                                    <span v-if="item.resps != undefined && item.resps.length > 1" @click="setShowRespComments(index)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.ver) }} {{ item.resps.length }} {{ getInterText(inter_ind.respostas) }}</span>
                                                </div>
                                                <div v-else style="color: #acadaf; margin-top: 1vw; margin-bottom: 1vw;">
                                                    <span v-if="item.resps != undefined && item.resps.length == 1" @click="setShowRespComments(index)" onMouseOver="this.style.cursor='pointer'">{{getInterText(inter_ind.resposta)}}:</span>
                                                    <span v-if="item.resps != undefined && item.resps.length > 1" @click="setShowRespComments(index)" onMouseOver="this.style.cursor='pointer'">{{getInterText(inter_ind.respostas)}}:</span>
                                                </div>

                                                <textarea v-if="showResponder==index" type="text" class="search" style="width: 100%;" :placeholder="getInterText(inter_ind.responda_comentario)" v-model="commentRespTx"></textarea>
                                            </div>
                                            <div v-if="showResponder==index" style="display: flex; justify-content: flex-end;">
                                                <div style="background-color: var(--bg-purple); border-radius: 10px;" onMouseOver="this.style.cursor='pointer'" @click="addCommentary(item.id, index)">
                                                    <span style="color: white; padding-right: 10px; padding-left: 10px;">{{ getInterText(inter_ind.enviar_resposta) }}</span>
                                                </div>
                                            </div>






                                            <div v-if="showRespComments==index" v-for="(itemResp, indexResp) in item.resps" style="display: flex; flex-direction: column; width: 100%; position: relative;" :key="itemResp.id">
                                                <div style="display: flex; align-items: flex-start; margin-bottom: 2vw; position: relative; height: 100%;">
                                                    <div style="display: inline-block; text-align: start; width: 12%; height: 100%;">
                                                        <img onerror="tryReloadImages(this)" v-if='hasHttp(itemResp.userPhoto)'  :src='unscapePath(itemResp.userPhoto)' alt="profile" class="im1" style="object-fit: cover;" :title="itemResp.userName">
                                                        <img onerror="tryReloadImages(this)" v-else :src='baseUrlImg + "PROFILE/" +itemResp.userPhoto'               alt="profile" class="im1" style="object-fit: cover;" :title="itemResp.userName">
                                                    </div>
                                                    <div style="display: flex; flex-direction: column; width: 74%; align-self: flex-start; margin-left: 1%;">
                                                        <div style="display: inline-block; position: relative; vertical-align: top; text-align: justify;">
                                                            <span style="color: darkblue">{{ getFirstAndLastWords(itemResp.userName) }}</span>
                                                            <span>{{ calcBehindTime(itemResp.data) }}</span>
                                                            <img v-if="user.sucess && itemResp.idUsuario == user.id" src="/static/imgs/bt_erase.png" alt="profile" class="im_del_comment" @click="rmCommentary(itemResp.id)">
                                                        </div>
                                                        <div v-if="renderCommentaries" class="translate" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">
                                                            <!--<div id="trans_area" class="translate_control" style="font-weight: bold; background-color: purple; display: none;">-->
                                                            <!--</div>-->
                                                            {{ itemResp.tx_trans }}
                                                        </div>
                                                        <span @click="setShowResponder2(indexResp)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.responder) }}</span>
                                                        <textarea v-if="showResponder2==indexResp" type="text" class="search" style="width: 100%;" :placeholder="getInterText(inter_ind.responda_comentario)" v-model="commentRespTx"></textarea>
                                                        <div v-if="showResponder2==indexResp" style="display: flex; justify-content: flex-end;">
                                                            <div style="background-color: var(--bg-purple); border-radius: 10px;" onMouseOver="this.style.cursor='pointer'" @click="addCommentary(item.id, index)">
                                                                <span style="color: white; padding-right: 10px; padding-left: 10px;">{{ getInterText(inter_ind.enviar_resposta) }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="div_joia2" style="margin-top: 2vw;">
                                                        <img v-if="isLiked(itemResp.id)" onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(itemResp, 0)" src="/static/imgs/ic_like_on.png" alt="joia up" class="im_joia1">
                                                        <img v-else onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(itemResp, 1)"  src="/static/imgs/ic_like_off.png"  alt="joia up" class="im_joia1">
                                                        <span style="margin-left: 5%;">{{ itemResp.qLikes }}</span>
                                                    </div>
                                                </div>
                                            </div>







                                        </div>
                                        <div class="div_joia2" style="margin-top: 2vw;">
                                            <img v-if="isLiked(item.id)" onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(item, 0)" src="/static/imgs/ic_like_on.png" alt="joia up" class="im_joia1">
                                            <img v-else onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(item, 1)"  src="/static/imgs/ic_like_off.png"  alt="joia up" class="im_joia1">
                                            <span style="margin-left: 5%;">{{ item.qLikes }}</span>
                                        </div>
                                    </div>
                                    <!--<hr style="margin-top: 5px; width: 100%;">-->
                                </div>

                            </div>



                        </div>
                    </div>
                </div>

                <!-- ################    Patrocinados, Caixa Mais info. e Advices Indica   ################# -->
                <div align="center" class="bodyp2">

                    <!--Barra de patrocinadores -->
                    <div class="div_pat" >
                        <span class="tx_parceiros">{{ getInterText(inter_ind.parceiros) }}</span>
                        <a v-for="item in barra_pat" :href="item.url" target=”_blank”><img onerror="tryReloadImages(this)" :src="item.imgPath" class="im_pat"/></a>
                    </div>

                    <!-- ################    Caixa Mais info.    ################# -->
                    <div class="bodysubp21">
                        <!--<div style="text-align: center;">-->
                            <!--<span style="font-size: 20pt" v-if="estab.tbTrajeEstabelecimentos!=null && estab.tbTrajeEstabelecimentos.length > 0">{{ getInterText(inter_ind.traje) }}</span>-->
                            <!--<br>-->
                            <!--<div v-for="item in estab.tbTrajeEstabelecimentos" class="traje">-->
                                <!--<span style="font-size: 12pt; text-align: center">{{ getInterText(item.nome) }}</span>-->
                                <!--<img :src="baseUrlImg + 'TRAJE/' + item.imgPath" alt="traje" class="im1">-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div style="background-color: white; height: 0.15vw; min-width: 25vmin; margin: 1.5vw;"/>-->

                        <!-- Mais Info - Separator -->
                        <div style="height: 4vh; width: 100%; display: flex; flex-direction: row; align-items: center; margin-top: -3vh; margin-bottom: 2vh;">
                            <img src="/static/imgs/ic_plus.png" style="width: 12%; object-fit: contain;">
                            <div style="background-color: #bdbfc1; width: 100%; height: 1px;"/>
                        </div>

                        <!-- Mais Info - Responsavel -->
                        <div class="tx_maisinfo" v-if="estab.responsavel!=null && estab.responsavel!=undefined && estab.responsavel!='undefined' && estab.responsavel.length>1"><span style="font-family: Humanst521BT">{{ getInterText(inter_ind.responsavel) }}: </span>{{ estab.responsavel }}</div>

                        <!-- Mais Info - Horario -->
                        <div v-if="estab.horario!=null && estab.horario.length>0" style="width: 100%; display: flex; margin-bottom: 2vh; margin-top: 1vh">
                            <div style="width: 12%; display: flex; justify-content: flex-start; align-items: center;">
                                <img src="/static/imgs/ic_horario.png" alt="local" style="width: 90%; object-fit: contain; margin-left: -12%;">
                            </div>
                            <div style="width: 88%; text-align: left;">
                                <span class="tx_maisinfo" style="white-space: pre-line; text-align: center; margin-bottom: 1vh">{{ estab.horario }}</span>
                            </div>
                        </div>

                        <!-- Mais Info - Site -->
                        <div v-if="estab.site!=null && estab.site!=undefined && estab.site.length > 1" style="width: 100%; display: flex; margin-bottom: 2vh; margin-top: 1vh">
                            <div style="width: 12%; display: flex; justify-content: flex-start; align-items: center;">
                                <img src="/static/imgs/ic_site.png" alt="local" style="width: 90%; object-fit: contain; margin-left: -12%;">
                            </div>
                            <div style="width: 88%; text-align: left;">
                                <a class="tx_maisinfo" style="color: blue" :href="getSiteUrl(estab.site)" target="_blank">{{ estab.site }}</a>
                            </div>
                        </div>

                        <!-- Mais Info - Endereco -->
                        <div style="width: 100%; display: flex; margin-bottom: 2vh; margin-top: 1vh">
                            <div style="width: 12%; display: flex; justify-content: flex-start; align-items: center;">
                                <img src="/static/imgs/ic_local_b.png" alt="local" style="width: 70%; object-fit: contain; margin-left: -5%;">
                            </div>
                            <div style="width: 88%; text-align: left;">
                                <div style="display: flex; flex-direction: column;">
                                    <div v-if="getAddressRuaNumBairro(estab).length > 37" style="display: flex; flex-direction: column;">
                                        <span class="tx_maisinfo" v-if="getAddressRuaNum(estab).length > 1">{{ getAddressRuaNum(estab) }}</span>
                                        <span class="tx_maisinfo" v-if="getAddressBairroComp(estab).length > 1">{{ getAddressBairroComp(estab) }}</span>
                                    </div>
                                    <div v-else style="display: flex; flex-direction: column;">
                                        <span class="tx_maisinfo" v-if="getAddressRuaNumBairro(estab).length > 1">{{ getAddressRuaNumBairro(estab) }}</span>
                                        <span class="tx_maisinfo" v-if="getAddressComp(estab).length > 1">{{ getAddressComp(estab) }}</span>
                                    </div>
                                </div>
                                <span class="tx_maisinfo" v-if="(estab.cidade!=null && estab.cidade.length>0) && (estab.cep!=null && estab.cep.length>0)">{{ estab.cidade }} - {{ estab.cep }}</span>
                                <span class="tx_maisinfo" v-if="(estab.cidade==null || estab.cidade.length==0) && (estab.cep!=null && estab.cep.length>0)">CEP: {{ estab.cep }}</span>
                                <span class="tx_maisinfo" v-if="(estab.cidade!=null && estab.cidade.length>0) && (estab.cep==null || estab.cep.length==0)">{{ estab.cidade }}</span>
                            </div>
                        </div>


                        <div style="text-align: center; display: flex; justify-content: space-evenly; margin-bottom: 1vh; width: 100%;">
                            <a style="width: 47%;" target="_blank" :href="'https://www.google.com/maps/search/?api=1&query=' + getAddressP1(estab)">
                                <div class="button_blue_c_d">
                                    <span style="position: relative; font-size: 1vw;">{{ getInterText(inter_ind.como_chegar) }}</span>
                                </div>
                            </a>
                            <a style="width: 47%;" v-if="(estab.telefones!=null && estab.telefones.length>0)" :href="'tel:' + trimAll(estab.telefones)">
                                <div class="button_white_c_d">
                                    <img src="/static/imgs/ic_tel_b.png" class="im1_2"/>
                                    <span style="font-size: 1vw; margin-right: 1vh;">{{ getInterText(inter_ind.ligar) }}</span>
                                </div>
                            </a>
                        </div>

                    </div>


                    <!-- ################    Adivce Indica    ################# -->
                    <div v-if=hasAnuncios(estab.id)>
                        <!-- Mais Info - Separator -->
                        <div style="height: 4vh; width: 100%; display: flex; flex-direction: row; align-items: center; padding-left: 10px;">
                            <img src="/static/imgs/ic_plus.png" style="width: 12%; object-fit: contain;">
                            <div style="background-color: #bdbfc1; width: 100%; height: 1px;"/>
                        </div>

                        <span class="tx_anun_title1">Dica Advice:</span>
                        <div class="div_anun_con">
                            <div v-for="(value, index) in getAnunciosDecoded(anuncios, estab.id)" class="div_anun_item">
                                <img v-if="value.photos !== undefined" onerror="tryReloadImages(this)" class="im_anum" :src="baseUrlImg + '/MARCADOR/' + value.photos[0].file">
                                <!--<img class="im_anum" style="background-attachment: red;" src="/static/imgs/ic_profile2.png"/>-->
                                <div class="dv_anum_t_c">
                                    <span class="tx_anun_title" style="margin-top: 0.5vh; margin-bottom: 0.5vh; text-align: left;" v-html="decodeChars(value.titulo)"></span>
                                    <!--<div style="display: flex; flex-direction: column; align-items: flex-end;">-->
                                        <!--<span class="tx_anun_sub1" style="">A partir de</span>-->
                                        <!--<div style=" display: flex;">-->
                                            <!--<span class="tx_anun_cifrao">R$</span>-->
                                            <!--<span class="tx_anun_title">{{ getCurrency(value.valor) }} </span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                </div>
                                <a v-if="value.tipo == 0" target="_blank" :href="value.link" style="width: 65%; display: flex">
                                    <span class="bt_anun"> {{ getInterText(inter_ind.comprar) }} </span>
                                </a>
                                <div v-else @click="goToEstabFromAnun(value.link)" style="width: 65%; display: flex">
                                    <span class="bt_anun"> {{ getInterText(inter_ind.ver) }} </span>
                                </div>
                            </div>

                        </div>
                    </div>



                </div>
                <br>
                <br>

            </div>

            </div>
        </div>

        </div>

        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%; margin-right: -45vw;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_fechar_w.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>


                <!--<div class="div_face_w" style="margin-top: 5vh;" @click="externalLoginFace_checkLoginState()">-->
                    <!--<div class="div_faceim">-->
                        <!--<img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">-->
                    <!--</div>-->

                    <!--<div class="div_facetx">-->
                        <!--<span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>-->
                    <!--</div>-->

                    <!--<img v-if="loading.face" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">-->
                <!--</div>-->


                <!--<div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">-->
                <div class="div_face_w" style="margin-top: 9vh; margin-bottom: 4vh" @click="externalLoginGoogle_startApp()">
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>

                    <img v-if="loading.google" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">
                </div>





                <div class="div_nome_l">
                    <!--<span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>-->
                    <!--<div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>-->
                    <span class="tx_nome_w" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" :class="editing[1].status ? 'input_name_w' : 'input_name_w_d'" type="text" v-model="editing[1].texto" tabindex="3" placeholder="E-mail" @click="clickInput(1, true)" autocapitalize="none"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <!--<span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>-->
                    <!--<div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>-->
                    <span class="tx_nome_w" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <div style="display: flex; flex-direction: row;">
                        <input id="nameid" :class="editing[0].status ? 'input_name_w' : 'input_name_w_d'" :type='editing[0].show ? "text" : "password"' v-model="editing[0].texto" :placeholder="getInterText(inter_ind.senha)" tabindex="4" @click="clickInput(0, true)"/>
                        <img v-if="editing[0].status" :src='editing[0].show ? "/static/imgs/ic_eye_open_w.png" : "/static/imgs/ic_eye_close_w.png"' style="width: 5vh; object-fit: contain;" @click="showPass(0)">
                    </div>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>
                </div>

                <div class="div_check" style="margin-top: 4vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1">{{ getInterText(inter_ind.entrar_auto) }}</span>
                    <span class="tx_check" style="cursor: pointer;" @click="goToEditUser">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>

                <div class="div_check" style="margin-top: 1vh;">
                    <div class="div_check_in" @click="changeCheckState(1)" onMouseOver="this.style.cursor='pointer'">
                        <span v-if="valid.termos" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check">{{ getInterText(inter_ind.li_concordo_com) }}&nbsp;<a href="/mPolitica" style="font-weight: bold">{{ getInterText(inter_ind.politica_privacidade) }}.</a></span>
                </div>

                <span v-if="senhaErrada" class="error_msg"> {{ getInterText(inter_ind.senha_errada) }} </span>
                <div style="text-align: center;">
                    <span v-if="userNaoCadastrado" class="error_msg"> {{ getInterText(inter_ind.usuario_nao_cadastrado) }}</span>
                </div>


                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 8vh;">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar_w unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>

                    </div>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'registerUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" style="font-weight: normal;"> {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>


        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_blue" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.0625
                 0 0 0 0 0.375
                 0 0 0 0 0.672
                 0 0 0 1 0"/>
        </filter>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <div class="overlay" @click="changeSideBar()"></div>

        <div class="overgalery" @click="showGalery(false)">
            <div style="display: flex; flex-direction: column; height: 100%; justify-content: space-between; align-items: center; ">
                <div class="div_fechar_over">
                    <img src="/static/imgs/bt_fechar_2.png" class="im_close_m_photo">
                </div>
                <div class="div_galery" @click.stop.prevent="">
                    <img onerror="tryReloadImages(this)" v-if="estab.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + estab.tbFotos[getPhotoIndex(0)].file" alt="Foto Principal" class="imgGalery"/><br>
                    <div class="div_arrow_l">
                        <img src="/static/imgs/ic_left_2.png" onmouseover="this.src='/static/imgs/ic_left.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_left_2.png'" alt="Foto Anterior" @click="nextPhoto(-1)" class="im_arrow" >
                    </div>
                    <div class="div_arrow_r">
                        <img src="/static/imgs/ic_right_2.png" onmouseover="this.src='/static/imgs/ic_right.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_right_2.png'" alt="Foto Anterior" @click="nextPhoto(+1)" class="im_arrow">
                    </div>
                </div>
                <div style="display: flex; flex-direction: row; overflow-x: scroll; max-width: 100vw;" class="noScrollMenu" @click.stop.prevent="">
                    <div v-for="(photo, index) in estab.tbFotos">
                        <img onerror="tryReloadImages(this)" @click="setPhotoIndex(index)" :src="baseUrlImg + 'MARCADOR/' + photo.file" class="im_galery_min_sel" v-if="index === photoIndex">
                        <img onerror="tryReloadImages(this)" @click="setPhotoIndex(index)" :src="baseUrlImg + 'MARCADOR/' + photo.file" class="im_galery_min" v-else>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import axios from 'axios'
    import { advMixin } from '../scripts/advMixin'

    export default {
        mixins: [advMixin],
        name: 'Estabelecimento',
        data () {
            return {
                name: 'Estabelecimento',
                estabs: [],
                estabs_full: [],
                cats_full: [],
                photoIndex: 0,
                showShare: false,
                showingSearch: false,
                loading: {
                    cats: false,
                    estabs: false
                },
                response: {
                    status: "ok"
                },
                cat: {},
                fotosLateral: [
                    { path: "/static/imgs/fotos/fotop1.png", nome: "Local 1" },
                    { path: "/static/imgs/fotos/fotop2.png", nome: "Local 2" },
                    { path: "/static/imgs/fotos/fotop3.png", nome: "Local 3" },
                    { path: "/static/imgs/fotos/fotop4.png", nome: "Local 4" },
                    { path: "/static/imgs/fotos/fotop5.png", nome: "Local 2" },
                    { path: "/static/imgs/fotos/fotop3.png", nome: "Local 4" },
                    { path: "/static/imgs/fotos/fotop2.png", nome: "Local 3" }
                ],
                comentarios: [
                    {
                        id: 0,
                        texto: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ut vehicula sapien. Maecenas laoreet orci non lorem malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ut vehicula sapien. Maecenas laoreet orci non lorem malesuada. Maecenas quis maximus libero. Pellentesque scelerisque feugiat diam, sit amet convallis sapien ultricies ut",
                        usuario: "Maria",
                        path: "/static/imgs/ic_perfil.png",
                        joia: 1
                    },
                    {
                        id: 1,
                        texto: "Donec ornare sit amet metus et vestibulum. Aliquam ac massa pulvinar, sagittis dolor nec, ultrices massa. Curabitur sem leo. Maecenas quis maximus libero. Pellentesque scelerisque feugiat diam, sit amet convallis sapien ultricies ut",
                        usuario: "Pedro",
                        path: "/static/imgs/ic_perfil.png",
                        joia: 0
                    },
                    {
                        id: 2,
                        texto: "Maecenas quis maximus libero. Pellentesque scelerisque feugiat diam, sit amet convallis sapien ultricies ut. Donec ornare sit amet metus et vestibulum. Aliquam ac massa pulvinar, sagittis dolor nec, ultrices massa. Curabitur sem leo.",
                        usuario: "Joao",
                        path: "/static/imgs/ic_perfil.png",
                        joia: -1
                    }
                ],
                panoInd: 0,
                pano: [
                    { imgPath: "static/imgs/pano_d_01.jpg", shift: 0, shift_m: 150 },
                    { imgPath: "static/imgs/pano_d_02.jpg", shift: 0, shift_m: 160 },
                    { imgPath: "static/imgs/pano_d_03.jpg", shift: 0, shift_m: 40 },
                    { imgPath: "static/imgs/pano_d_04.jpg", shift: 0, shift_m: 60 },
                    { imgPath: "static/imgs/pano_d_05.jpg", shift: 0, shift_m: 130 },
                    { imgPath: "static/imgs/pano_d_06.jpg", shift: 0, shift_m: 130 },
                    { imgPath: "static/imgs/pano_d_07.jpg", shift: 0, shift_m: 130 },
                    { imgPath: "static/imgs/pano_d_08.jpg", shift: 0, shift_m: 130 },
                    { imgPath: "static/imgs/pano_d_09.jpg", shift: 0, shift_m: 130 }
                ]
            }
        },
        watch: {
            '$route.params': function (newQuestion, oldQuestion) {
                console.log('newQuestion ', newQuestion)
                console.log('oldQuestion ', oldQuestion)

                this.atualizaParametros();
            }
        },
        methods: {
            getReserveImage() {
                let idioma = this.user.idioma; // ou como você obtém o idioma atualmente
                if (idioma === 0) {
                    return "/static/imgs/reservarportesp.png";
                } else if (idioma === 1) {
                    return "/static/imgs/reservaringles.png";
                } else if (idioma === 2) {
                    return "/static/imgs/reservarportesp.png";
                }
                return "/static/imgs/reservarportesp.png";
            },
            goShare(id) {
                if (id === 7) {
                    const currentUrl = window.location.href;
                    navigator.clipboard.writeText(currentUrl).then(() => {
                    alert('Link copiado para a área de transferência!');
                    }).catch(err => {
                    console.error('Erro ao copiar o link: ', err);
                    });
                }
            },
            getAvalieNosImage() {
                let idioma = this.user.idioma; // ou como você obtém o idioma atualmente
                if (idioma === 0) {
                    return "/static/imgs/avaliarport.png";
                } else if (idioma === 1) {
                    return "/static/imgs/avaliaringles.png";
                } else if (idioma === 2) {
                    return "/static/imgs/avaliaresp.png";
                }
                return "/static/imgs/avaliarport.png";
            },
            share() {
                this.showShare = !this.showShare;
            },
            goToEditUser() {
                window.location.href = 'https://www.adviceparaiba.com/EditUser';
            },
            getInvestimento(estab) {
                if (estab.investimento > 5)
                    return 5;
                else
                    return estab.investimento;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if (top) while (--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            adjustCaracterEncoding() {
                var i;
                var vm = this;
                for (i = 0; i < vm.estabs_full.length; i++) {
                    try {
                        vm.estabs_full[i].nome = decodeURIComponent(escape(vm.estabs_full[i].nome));
                    } catch (e) {
                        vm.estabs_full[i].nome = unescape(vm.estabs_full[i].nome);
                    }
                    try {
                        vm.estabs_full[i].horario = decodeURIComponent(escape(vm.estabs_full[i].horario));
                    } catch (e) {
                        vm.estabs_full[i].horario = unescape(vm.estabs_full[i].horario);
                    }
                    try {
                        vm.estabs_full[i].responsavel = decodeURIComponent(escape(vm.estabs_full[i].responsavel));
                    } catch (e) {
                        vm.estabs_full[i].responsavel = unescape(vm.estabs_full[i].responsavel);
                    }
                    try {
                        vm.estabs_full[i].rua_num = decodeURIComponent(escape(vm.estabs_full[i].rua_num));
                    } catch (e) {
                        vm.estabs_full[i].rua_num = unescape(vm.estabs_full[i].rua_num);
                    }
                    try {
                        vm.estabs_full[i].bairro = decodeURIComponent(escape(vm.estabs_full[i].bairro));
                    } catch (e) {
                        vm.estabs_full[i].bairro = unescape(vm.estabs_full[i].bairro);
                    }
                    try {
                        vm.estabs_full[i].cidade = decodeURIComponent(escape(vm.estabs_full[i].cidade));
                    } catch (e) {
                        vm.estabs_full[i].cidade = unescape(vm.estabs_full[i].cidade);
                    }
                }
            },
            showGalery(show) {
                if (show)
                    $('.overgalery').fadeIn();
                else
                    $('.overgalery').fadeOut();
            },
            nextPhoto(inc) {
                if (inc >= 0)
                    this.photoIndex = (this.photoIndex + inc) % this.estab.tbFotos.length;
                else {
                    if (this.photoIndex == 0)
                        this.photoIndex = this.estab.tbFotos.length - 1;
                    else
                        this.photoIndex = (this.photoIndex + inc);
                }
            },
            getPhotoIndex(index) {
                return (this.photoIndex + index) % this.estab.tbFotos.length;
            },
            setPhotoIndex(index) {
                this.photoIndex = index;
            },
            submit(i, up) {
                console.log('Entrei no submit() ' + i);
                if (i.joia == 1) {
                    if (up) {
                        i.joia = 0;
                    }
                    else {
                        i.joia = -1;
                    }
                }
                else if (i.joia == -1) {
                    if (!up) {
                        i.joia = 0;
                    }
                    else {
                        i.joia = 1;
                    }
                }
                else {
                    if (up) {
                        i.joia = 1;
                    }
                    else {
                        i.joia = -1;
                    }
                }
            },
            getEstabs(idCat) {
                console.log('getEstabs ' + idCat);
                var vm = this;

                var estabs = [];

                if (idCat == undefined) {
                    return estabs;
                }

                if (idCat==-1) {
                    estabs = this.estabs_search;
                }
                else {
                    var i;
                    for (i = 0; i < vm.estabs_full.length; i++) {
                        var estab = vm.estabs_full[i];

                        var j;
                        for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                            var cat = estab.tbCategoriaEstabelecimentos[j];
                            if (cat.id == idCat) {
                                estabs.push(estab);
                            }
                        }
                    }
                }

                return estabs;
            },
            atualizaParametros() {
                console.log('atualizaParametros');
                // console.log(this.$route.query);

                if (this.$route.query.id == null) {
                    console.log('id eh nulo');
                } else {
                    this.idEstab = this.$route.query.id;
                    // console.log('id eh valido ' + this.idEstab);
                }

                this.getCities();

                console.log('vou chamar getCommentaries: ', this.idEstab)
                this.getCommentaries(0, this.idEstab);

                this.atualizaEstab(this.idEstab);
            },
            atualizaEstab(idEstab) {
                console.log('atualizaEstab ' + idEstab);
                // console.log('atualizaEstab ' + idEstab);
                // console.log('atualizaEstab ' + idEstab);
                // console.log('atualizaEstab ' + idEstab);

                var vm = this;

                window.scrollTo(0, 0)

                // console.log('location.href: ', location.href);
                // console.log('location.pathname: ', location.pathname);
                // console.log('1this.$router.currentRoute: ', this.$router.currentRoute)
                // console.log('1history.current: ', this.$router.history.current)
                // // console.log('history: ', this.$router.history)
                // console.log('1this.$router: ', this.$router)
                // console.log('1this.$route: ', this.$route)
                // console.log('1parent.location: ', parent.location)


                // Ta nesse for separado para que mesmo se nao tiver nenhum estabelecimento na categoria selecionada ele altere o tituloCat.
                var i;
                for (i=0 ; i<vm.estabs_full.length ; i++) {
                    var stab = vm.estabs_full[i];
                    if (stab.id == idEstab) {
                        vm.estab = stab;
                        vm.estab.descricao_trans = vm.estab.descricao2;

                        console.log('vm.descricao_trans: ', vm.estab.descricao_trans)
                        console.log('vm.descricao_trans: ', vm.estab.descricao_trans)
                        console.log('vm.descricao_trans: ', vm.estab.descricao_trans)
                        console.log('vm.descricao_trans: ', vm.estab.descricao_trans)
                        console.log('vm.descricao_trans: ', vm.estab.descricao_trans)
                        console.log('vm.descricao_trans: ', vm.estab.descricao_trans)

                        // console.log('this.$router.currentRoute.params.estabSimple', this.$router.currentRoute.params.estabSimple)
                        // console.log('vm.estab.nomeSimple', vm.estab.nomeSimple)
                        // if (this.$router.currentRoute.params.estabSimple !== vm.estab.nomeSimple) {
                            console.log('vou dar o replaceState')
                            history.replaceState('Test', vm.estab.nome, '/s/' + vm.estab.nomeSimple)
                        // }
                        // this.$router.history.current.path = '/s/' + vm.estab.nomeSimple
                        // parent.location.hash = '/s/' + vm.estab.nomeSimple
                        // console.log('parent.location.pathname: ', parent.location.pathname)
                        // console.log('parent.location.pathname[1] ', parent.location.pathname[1])

                        // if (parent.location.pathname[1] === 'E') {
                        //     console.log('Vou atualizar o pathName')
                        //     // parent.location.pathname = '/s/' + vm.estab.nomeSimple
                        // } else {
                        //     console.log('Nao atualiza o pathName')
                        // }

                        break;
                    }
                }

                // console.log('2this.$router.currentRoute: ', this.$router.currentRoute)
                // console.log('2history.current: ', this.$router.history.current)
                // console.log('2this.$router: ', this.$router)
                // console.log('2this.$route: ', this.$route)
                // console.log('2parent.location: ', parent.location)

                var j = this.getEstabUserIndex(idEstab);
                if (j >= 0)
                    this.avaliacao = this.user.estabelecimentos[j].avaliacao;

                // descobre a categoria atual
                if (vm.estab!=null && vm.estab.tbCategoriaEstabelecimentos!=null)
                    for (i=0 ; i<vm.estab.tbCategoriaEstabelecimentos.length ; i++) {
                        var cat = vm.estab.tbCategoriaEstabelecimentos[i];
                        // 53 eh o ID de Destaques.
                        if (cat.id != 53) {
                            this.cat = cat;
                            if (cat.cor2.length<=1)
                                this.cat.cor2 = "var(--main-bg-color)";
                            // this.corCat = cat.cor;
                            // this.corCat2 = cat.cor2;
                            // this.tituloCat = cat.nome;
                            break;
                        }
                    }

                window.scrollTo(0, 0)
            },

            trimAll(str){
                return str.replace(/\s/g,'');
            }
        },

        created() {
            console.log('created do Estabelecimento!!');


            if (this.$route.params.indexCity != null) {
                this.cityIndex = this.$route.params.indexCity;
                // console.log('setando o cityIndex para: ', this.cityIndex);
            }

            if (this.$route.params.subCatIndex != null) {
                this.subCatIndex = this.$route.params.subCatIndex;
                // console.log('setando o subCatIndex para: ', this.subCatIndex);
            }

            if (this.$route.params.idCat != null) {
                this.idCat = this.$route.params.idCat;
                // console.log('1::idCat', this.idCat);
            }

            // Estab do preview do RegisterEstaFirst
            if (this.$route.query.estab != null) {
                let estab = decodeURI(this.$route.query.estab);
                let jsonStab = JSON.parse(estab);
                console.log('jsonStab: ', jsonStab);

                this.estab = jsonStab;
                this.estab.descricao_trans = this.estab.descricao2;

                console.log('descricao_trans: ', this.estab.descricao_trans)
                console.log('descricao_trans: ', this.estab.descricao_trans)
                console.log('descricao_trans: ', this.estab.descricao_trans)
                console.log('descricao_trans: ', this.estab.descricao_trans)
                console.log('descricao_trans: ', this.estab.descricao_trans)

                return;
            }
            else {
                if (this.$route.params.stabs) {
                    // console.log('Usando estabs e cats passados por parametro!!');
                    this.estabs_full = this.$route.params.stabs;
                    this.cats_full = this.$route.params.categs;
                    if (this.$route.params.idCat != null) {
                        this.idCat = this.$route.params.idCat;
                        // console.log('2::idCat', this.idCat);
                        this.cat.id = this.$route.params.idCat;
                    }
                    this.atualizaParametros();
                }
                else {
                    // console.log('this.$route.params.estabSimple: ', this.$route.params.estabSimple);
                    // console.log('Baixando estabs!!');
                    if (this.$route.params.estabSimple != null) {
                        this.getEstabsCatsHome(this.$route.params.estabSimple);
                    } else {
                        this.getEstabsCatsHome();
                    }
                }

                if (this.$route.query.id != null)
                    this.idEstab = this.$route.query.id;
            }

            if (this.$route.params.anuncios) {
                console.log('Usando anuncios passados por parametro!!');
                this.anuncios = this.$route.params.anuncios;
            }
            else {
                console.log('Baixando anuncios!!');
                this.getAnuncios();
            }

            // if (this.$route.params.user) {
            //     this.user = this.$route.params.user;
            // }

            console.log('Terminei o created do Estabelecimento!!');
        },

        mounted() {
            console.log('mounted do Estabelecimento!!');

            // $(document).ready(function () {
            //     $('#dismiss, .overlay').on('click', function () {
            //         $('#div_pat_s').fadeOut(0);
            //         $('#sidebar').removeClass('active');
            //         $('.overlay').fadeOut();
            //     });
            //
            //     $('#sidebarCollapse').on('click', function () {
            //         $('#sidebar').addClass('active');
            //         $('.overlay').fadeIn();
            //         $('.collapse.in').toggleClass('in');
            //         $('a[aria-expanded=true]').attr('aria-expanded', 'false');
            //         $('#div_pat_s').fadeIn();
            //     });
            // });

            $('#div_pat_s').fadeOut(0);

            this.barra_pat = this.shuffle(this.barra_pat);

            if (this.user.idioma > 0) {
                this.changeIdioma(this.user.idioma);
            }

            window.scrollTo(0, 0)

            // window.history.deleteUrl({url: 'https://localhost:8080/goEstab'});

            console.log('Terminei o mounted do Estabelecimento!!');
        }
    }
</script>



<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/advDesk.css" scoped/>
<style src="../assets/css/advGeral.css" scoped/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        background-color: var(--main-bg-color-new);
    }
    .wrapper {
        background-color: var(--main-bg-color-new);
    }
    html, body {
        background-color: var(--main-bg-color-new);
    }

    .traje {
        display: inline-block;
        width: 60px;
        vertical-align: middle;
        text-align: center;
        margin-left: 5px;
        margin-right: 5px;
    }
    .im1 {
        display: inline-block;
        width: 7vh;
        height: 7vh;
        margin-right: 1%;
        vertical-align: middle;
        text-align: center;
        border-radius: 50%;
        background-size: contain;
        object-fit: cover;
    }

    .im_social {
        display: inline-block;
        /*width: 35px;*/
        height: 90%;
        width: 100%;
        margin-top: 0.2vh;
        /*padding: 3px;*/
        object-fit: scale-down;
        /*padding: 0.1vw;*/
        vertical-align: middle;
    }
    .bar_idiomas {
        display: flex;
        vertical-align: middle;
        /*padding-left: 1vw;*/
        align-items: center;
        justify-content: space-evenly;
        background-image: url('/static/imgs/ic_barra_idiomas_w.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 3.5vh;
    }
    .default-share {
        filter: none;
    }
    .active-share {
        filter: brightness(0) saturate(100%) invert(33%) sepia(77%) saturate(2380%) hue-rotate(179deg) brightness(95%) contrast(91%);
    }
    .imF1 {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
        background-color: var(--empty-color);
    }
    .imF2 {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
        background-color: var(--empty-color);
    }
    .divF1 {
        position: relative;
        display: inline-block;
        /*width: 660px;*/
        /*background-color: red;*/
        width: 100%;
        /*height: 450px;*/
        /*height: 32vw;*/
        height: var(--estab-estab-height);
    }
    .divF2, .divF3 {
        display: inline-block;
        /*width: 310px;*/
        width: 100%;
        /*background-color: red;*/
        /*height: 217px;*/
        /*height: 15.5vw;*/
        /*height: 19.5vh;*/
        height: var(--estab-estab-height_2);
    }
    .divF3 {
        /*margin-top: 15px;*/
        /*margin-top: 1vh;*/
        margin-top: 0.5vh;
    }
    .im_star {
        position: relative;
        height: 100%;
        background-image: url('/static/imgs/ic_estrela_filled.png');
        background-repeat: no-repeat;
        /*background-size: cover;*/
        background-size: auto 100%;
    }
    .di_star_wrap {
        /*background-color: blue;*/
        background-image: url('/static/imgs/ic_estrela_empty.png');
        background-repeat: no-repeat;
        background-size: contain;
        display: flex;
        position: relative;
        max-width: 11vw;
        width: 11vw;
        height: 2vw;

    }
    .di_cifrao {
        /*background-color: #0094D9;*/
        background-color: #355587;
        height: 2.7vw;
        position: relative;
    }
    .di_cifrao {
        /*background-color: #FCB713;*/
    }
    .im_categoria2 {
        width: 30px;
        height: 30px;
        width: 2.8vh;
        height: 2.8vh;
        margin-left:17px;
        margin-left:17px;
        margin-right:10px;
        margin-right: 0.4vw;

        object-fit: contain;
        filter: url(#colorize_blue);
    }
    .im_joia1, .im_joia2 {
        width: 25%;
        object-fit: contain;
        max-height: 50px;
        margin-bottom: 10px;
    }
    .im_joia2 {
        margin-bottom: 0px;
    }
    .div_joia {
        width: 80px;
        position: absolute;
        bottom: 16px;
        right: 8px;
    }
    .back01 {
        /*background-color: #E4E4E4;*/
        background-color: var(--main-bg-color-new);
        /*background-color: red;*/
        display: flex;
        flex-direction: row;
        position:relative;
        height: auto;
        margin-top: calc(var(--top-bar-heigth_desk) + 4vh);
    }
    .bodyp1 {
        /*background-color: #E4E4E4;*/
        /*background-color: pink;*/
        display:inline-block;
        text-align: left;
        width: 75%;
        height: 100%;
    }
    .bodyp2 {
        /*background-color: #FCB713;*/
        /*background-color: purple;*/
        display: flex;
        flex-direction: column;
        /*justify-content: center;*/
        text-align: right;
        width: 25%;
        /*height: 100%;*/
        /*height: auto;*/
        justify-content: flex-start;
        /*position: absolute;*/
    }
    .bodysubp12 {
        font-size: 0;
        margin-right: 5%;
        margin-left: 5%;
        /*background-color: saddlebrown;*/
        position: relative;
        text-align: center;
    }
    .bodysubp1 {
        /*background-color: darkred;*/
        display:inline-block;
        text-align: justify;
        vertical-align: top;
        position: relative;
        width: 59.5%;
        margin-right: 0.5%;
    }
    .bodysubp2 {
        /*background-color: darkorange;*/
        position: relative;
        display: inline-block;
        text-align: center;
        width: 39%;
    }
    .bodysubp21 {
        /*background-color: lightgrey;*/
        /*background-color: var(--ligth-gray);*/
        background-size: 100% 100%;
        display: flex;
        position: relative;
        flex-direction: column;
        justify-content: center;
        padding: 10px;
        text-align: center;
        width: 100%;
        color: var(--font-dark-gray);
        height: auto;
        /*max-height: 40vh;*/
        /*flex-grow: 1;*/
    }
    .bodysubp3 {
        /*background-color: green;*/
        margin-left: 5%;
        margin-right: 5%;
    }
    .small-share-img {
    height: 3.5vw; 
    object-fit: contain;
    }

    .title0 {
        /*margin-top: 16.5vh;*/
        margin-top: calc(var(--top-bar-heigth_desk) + 4vh);
        /*margin-top: 0.5vw;*/
        /*display: inline-block;*/
        /*background-color: #E4E4E4;*/
        z-index: -2;
    }
    .title3, .title3_v2 {
        display: flex;
        text-align: left;
        font-size: 20pt;
        font-size: 2.6vh;
        background-color: white;
        border-radius:10px;
        margin-right: 1vw;
        margin-left: 1vw;
        margin-bottom: 1vw;
        /*padding-top: 0.6vw;*/
        /*padding-bottom: 0.6vw;*/
        /*padding-top: 0.8vh;*/
        /*padding-bottom: 0.5vw;*/
        height: 5.5vh;
        align-items: center;
        align-content: center;
        justify-content: left;
        /*background-color: red;*/
    }

    .title3_v2 {
        /*margin-right: 0;*/
        /*margin-left: 0;*/

        border-radius: unset;

        border-bottom-color: var(--ligth-gray);
        border-bottom-style: solid;
        border-bottom-width: 0.2vh;
    }

    /*.search {*/
        /*background-image: url("/static/imgs/bg_area_comment.png");*/
        /*background-color: transparent;*/
        /*background-repeat: no-repeat;*/
        /*background-size: 100% 100%;*/
        /*width: 90%;*/
        /*height: 46px;*/
        /*border: none;*/
        /*padding: 10px;*/
        /*vertical-align: top;*/
        /*margin-top: 0;*/
        /*font-size: 12pt;*/
        /*text-anchor: start;*/
        /*text-align: initial;*/
    /*}*/
    .search {
        -moz-box-shadow:    inset 0 1px 2px #666666;
        -webkit-box-shadow: inset 0 1px 2px #666666;
        box-shadow:         inset 0 1px 2px #666666;
        border-radius: 10px;
        /*background-image: url("/static/imgs/bg_area_comment.png");*/
        background-color: transparent;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 90%;
        /*height: 46px;*/
        height: 17vh;
        border: none;
        outline: none;
        padding: 10px;
        vertical-align: top;
        margin-top: 0;
        font-size: 12pt;
        text-anchor: start;
        text-align: initial;
    }
    .title2_coment {
        vertical-align: text-top;
    }

    .div_arrow_l, .div_arrow_r {
        position: absolute;
        top:0;
        height: 100%;
        min-width: 40px;
        vertical-align: center;
    }
    .div_arrow_r {
        right: 10px;
    }
    .div_arrow_l {
        left: 10px;
    }
    .im_arrow {
        position: absolute;
        vertical-align: middle;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -o-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;
    }
    .im_arrow:hover {
        -webkit-filter: brightness(70%);
        filter: brightness(70%);
    }

    .im_galery_min, .im_galery_min_sel {
        width: 5vw;
        height: 5vw;
        object-fit: contain;
        margin-right: 0.5vw;
    }

    .im_galery_min_sel, .im_galery_min:hover {
        border-width: 2px;
        border-color: white;
        border-style: solid;
    }

    .overgalery {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(10, 10, 10, 0.95);
        z-index: 1000;
        display: none;
        vertical-align: middle;
        top: 0;
    }
    .div_galery {
        vertical-align: middle;
        display: inline-block;
        z-index: 1;
        position: relative;
        width: 80%;
        /*top: 50%;*/
        /*left: 50%;*/
        padding-right: 10px;
        padding-left: 10px;
        text-align: center;
        /*transform: translate(-50%, -50%);*/
    }
    .im100_search {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        position: relative;
        object-fit: cover;
        /*clip: rect(0px,0px,100%,100%);*/
        /*height: 275px;*/
        /*margin-right: 100px;*/
        /*object-fit: cover;*/
    }

    .imgGalery {
        width: 70vw;
        height: 65vh;
        object-fit: contain;
    }
    .im1_2 {
        image-rendering: -webkit-optimize-contrast;
        /*-webkit-filter: brightness(0) invert(1);*/
        /*filter: brightness(0) invert(1);*/
        height: 50%;
    }
    .im_pat {
        /*background-color: red;*/
        height: 1.1cm;
        height: 5.1vh;
        /*margin-left: 0.1cm;*/
        /*margin-right: 0.1cm;*/
        /*margin-bottom: 0.75cm;*/
        /*margin-top: 0.2cm;*/
        object-fit: contain;
    }
    .div_pat {
        display: flex;
        flex-direction: column;
        position: relative;
        /*bottom: 0;*/
        /*background-color: #C4C4C4;*/
        /*background-color: #CDCDCD;*/
        /*background-color: #949494;*/
        /*background-color: blue;*/
        /*background-color: red;*/
        margin-top: 0;
        /*margin-top: 1vw;*/
        padding-top: 0.25cm;
        width: 100%;
        height: content-box;
        height: 40vh;
        max-height: 40vh;
        /*text-align: center;*/
        /*justify-content: flex-start;*/
        align-items: center;
        justify-content: space-evenly;
        /*flex-grow: 9;*/
    }
    .tx_parceiros {;
        font-size: 12pt;
        /*color: #040505;*/
        color: #858585;
    }
    .im_pat_s {
        height: 0.7cm;
        margin-left: 0.2cm;
        margin-right: 0.2cm;
        margin-bottom: 0.2cm;
        margin-top: 0.2cm;
    }
    .div_pat_s {
        width: 250px;
        padding-top: 0.15cm;
        /*position: absolute;*/
        position: fixed;
        display: inline-block;
        vertical-align: bottom;
        top: auto;
        left: 0;
        bottom: 0px;
        z-index: 999;
        background-color: #C4C4C4;
        background-color: #CDCDCDBB;
        /*background-color: #E4E4E4;*/
        /*background: #549CCB;*/
        text-align: center;
    }
    .tx_parceiros_s {;
        font-size: 9pt;
        /*color: #040505;*/
        color: #858585;
    }

    .div_botao, .div_botao_t_b, .div_botao_t_w, .div_botao_m {
        display: flex;
        align-items: center;
        padding: 2vh;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 1vh;
    }

    .div_botao_t_w {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1vh;
        color: white;
        width: 80%;
    }

    .div_botao_t_w {
        border-style: none;
        background: white;
        padding: 1.3vh;
        height: 5vh;
        color: var(--bg-blue);
    }

    .div_botao_t {
        display: flex;
        align-items: center;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 1vh;
    }

    .reserve-button {
        padding-right: 1.5%;
        padding-left: 85%;
        width: auto;
        height: 47px; /* Ajuste a altura conforme necessário para corresponder ao tamanho do texto original */
        vertical-align: middle; /* Alinha a imagem com o texto circundante */
        background-color: transparent;
    }


    .div_botao_t {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1.3vh;
        height: 5vh;
        color: white;
        cursor: pointer;
        width: 80%;
    }

    .div_botao_t:active {
        border-color: var(--bg-blue);
        background: white;
        color: var(--bg-blue);
    }

    .tx_continuar {
        display: flex;
        flex-direction: row;
        font-weight: normal;
        color: unset;
        font-size: 2.5vh;
        /*font-family: 'Humanst521LTBT', Helvetica, Arial,sans-serif;*/
    }

    .div_botao_t.tx_continuar:active {
        color: var(--bg-blue);
    }

    .custom-select-filtro {
        width: 60%;
        height: 4.5vh;
        background-color: var(--bg-blue-grad1);
        border-color: transparent;
        border-width: 1px;
        border-style: solid;
        text-align: center;

        margin-right: 2.5%;
        margin-left: 2.5%;
        margin-top: 1.5vh;
        margin-bottom: -1.5vh;

        display: flex;
    }

    select#sel_cats {
        margin-left: 2vw;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;       /* Remove default arrow */
        outline: none;
        background-color: var(--bg-blue-grad1);
        /*background-color: red;*/
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: none;
        padding-left: 2%;
        /*font-size: 12pt;*/
        font-size: 2vh;
    }

    .hr_pat {
        width: 85%;
        margin-top: 0;
        margin-bottom: 5%;
        color: white;
        background-color: white;
        border-color: white;
    }


    .im_pat_m {
        /*background-color: #0f62ac;*/
        width: 85%;
        /*margin-right: 2%;*/
        /*margin-bottom: 2%;*/

    }

    .div_pat_m {
        position: page;
        bottom: 0;
        width: 100%;
        display: inline-block;
        /*background-color: #CDCDCD;*/
        padding-top: 0;
        /*padding-bottom: 0.5cm;*/
        text-align: center;
        background-color: transparent;
        /*background-color: pink;*/
        /*background-color: #0171bb;*/
        /*position: fixed;*/
        /*bottom: 0;*/
        width: 100%;
        height: 6%;
        /*display: inline-block;*/
        /*margin-bottom: 5vh;*/
        flex-grow: 10;
        flex-shrink: 0;
    }

    #dismiss {
        top: 0;
        left: 0;
        margin-left: 5px;
        margin-top: 10px;
    }

    .im_fav_m,
    .im_share {
        width: 3.8vh; /* Define uma largura fixa baseada na altura da viewport */
        height: 3.8vh; /* Define uma altura fixa baseada na altura da viewport */
        margin-top: 0.75vw; /* Define uma margem superior baseada na largura da viewport */
        margin-right: 0.5vw; /* Define uma margem direita baseada na largura da viewport */
        cursor: pointer; /* Adiciona o cursor de ponteiro ao passar o mouse */
        object-fit: contain; /* Garante que a imagem se ajuste ao contêiner sem distorcer */
    }


    .button_white_a, .button_white_a2, .button_white_a_d {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding-right: 5vw;
        padding-left: 5vw;
        margin-left: 2vw;
        margin-top: 1vw;
        margin-bottom: 1vw;
        color: white;
        background-color: var(--bg-round-rect2);
        border-radius:10px;
    }

    .button_white_a2 {
        background-color: unset;
        background-image: url('/static/imgs/ic_aval.png');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        margin-bottom: 0;
    }

    .di_star_popup {
        display: flex;
        /*width: 34%;*/
        height: 25vh;
        padding: 2vh;
        padding-right: 3%;
        padding-left: 3%;
        padding-top: 1vh;
        justify-content: space-between;
        align-content: space-around;
        align-items: center;
        justify-items: center;
        flex-direction: column;
        position: absolute;
        margin-top: 2.5vh;
        left: 3.8%;
        background: white;
        -webkit-box-shadow: 0 0 3px #AAAAAADD;
        -moz-box-shadow: 0 0 3px  #AAAAAADD;
        box-shadow: 0 0 3px #AAAAAADD;
        border-radius: 4px;
        font-size: 3vh;
        z-index: 1000;
    }

    .im_star_single, .im_star_single_fill {
        width: 5vh;
    }

    .di_stab_buttons {
        /*background-color: red;*/
        display: flex;

        width: 100%;
        align-items: flex-start;
        flex-grow: 1;
    }



    .im_del_comment {
        /*width: 20px;*/
        /*height: 20px;*/
        width: 1.5vw;
        height: 1.5vw;
        border-radius: 50%;
        cursor: pointer;
        object-fit: scale-down;
    }

    .button_white_c, .button_white_c_d, .button_blue_c_d {
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius:15px;
        width: 25vw;
        height: 3vh;
        text-align: center;
        vertical-align: center;
    }
    .button_white_c_d, .button_blue_c_d {
        /*background-color: white;*/
        color: var(--blue-font-tel);
        width: 100%;
    }

    .button_white_c_d {
        height: 4vh;
        border-color: var(--blue-font-tel);
        border-style: solid;
        border-width: 1px;
    }

    .button_blue_c_d {
        height: 4vh;
        background-color: var(--blue-back-chegar);
        color: white;
    }

    .im_cifrao {
        position: relative;
        height: 100%;
        width: auto;
        background-image: url('/static/imgs/ic_cifrao_filled.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-size: auto 100%;
        /*width: 50%;*/
        font-size: 0; border-width: 0; border: none;
    }

    .di_cifrao_wrap_estab {
        background-image: url('/static/imgs/ic_cifrao_empty.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        /*background-size: contain;*/
        /*display: flex;*/
        /*align-items: center;*/
        /*text-align: center;*/
        /*vertical-align: middle;*/
        justify-content: flex-start;
        /*position: relative;*/
        /*background-color: yellow;*/
        font-size: 0; border-width: 0; border: none;
    }

    .di_stab_buttons, .di_stab_buttons_m {
        /*background-color: red;*/
        display: flex;

        width: 100%;
        align-items: flex-start;
        flex-grow: 1;
    }

    .di_stab_buttons_m {
        /*background-color: purple;*/
        align-items: center;
        flex-direction: column;
        justify-content: center;
        flex-grow: unset;
    }

    .tx_maisinfo, .tx_maisinfo_s {
        font-size: 1vw;
        /*margin-bottom: 0.5vw;*/
        color: var(--bg-blue-circle);
    }

    .txt {
        font-size: 2.2vh;
        text-align: justify;
        display:block;
    }

    .avalie-nos-button {
        padding-right: 1.5%;
        padding-left: 1.5%;
        width: auto;
        height: 36px; /* Ajuste a altura conforme necessário para corresponder ao tamanho do texto original */
        vertical-align: middle; /* Alinha a imagem com o texto circundante */
        background-color: transparent;
    }


    /****************** Login window *****************/
    .div_login_m {
        /*background: rgba(1, 0, 0, .7);*/
        /*background: blue;*/
        flex-direction: column;
        display: flex;
        justify-content: center;
        position: fixed;
        align-items: center;
        top: 0;
        width: 100vw;
        height: 100vh;
        overflow-x: auto;
        overflow-y: auto;
        z-index: 1000;
    }

    .parts_m {
        background-color: blue;
        background-image: url('/static/imgs/bg_login.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        /*background: red;*/
        /*box-shadow: 5px 5px 5px black;*/
        width: 100vw;
        height: 100vh;
        /*height: max-content;*/
        display: flex;
        /*padding: 8vw;*/
        padding-top: 1vw;
        align-items: center;
        overflow-y: auto;
        flex-direction: column;
        padding-right: 30vw;
        padding-left: 30vw;
    }

    .tx_nome, .tx_nome_before, .tx_nome_before_w, .tx_nome_w, .tx_login3 {
        display: flex;
        width: 100%;
        font-size: 25pt;
        /*color: gray;*/
    }
    
    .tx_nome_w {
        color: white;
        font-size: 3vh;
    }

    .tx_nome_before_w {
        color: white;
        font-family: 'Humanst521BT';
        font-size: 3.5vh;
    }

    .hr, .hr_w {
        width: 100%;
        height: 2px;
        margin-top: 5px;
        background: gray;
    }

    .hr_w {
        background-color: white;
    }

    .error_msg {
        font-family: 'Humanst521BT';
        color: red;
        font-size: 2.5vh;
    }

    .div_check {
        display: flex;
        width: 100%;
        margin-top: 0;
        align-items: center;
    }

    .div_check_in {
        display: flex;
        border-width: 2px;
        border-style: solid;
        border-color: white;
        width: 15px !important;
        height: 15px !important;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        cursor: pointer;
    }

    .tx_checkbox {
        color: white;
        font-weight: bold;
        margin-top: -4px;
    }

    .tx_check {
        color: white;
        font-style: normal;
        text-align: center;
        display: flex;

        font-weight: normal;
        display: flex;
        font-size: 9pt;
        font-size: 2.5vh;
        margin-left: 1.5vw;

        justify-items: flex-end;
        align-content: flex-end;
        alignment-baseline: bottom;
    }

    .div_botao_login {
        border-style: solid;
        border-color: white;
        border-width: 1px;
        width: 15vw;
        height: 5vh;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        /*background: white;*/

        color: white;
    }

    .div_face, .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 2vh;
        width: 100%;
        display: flex;
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
    }

    .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;

        display: flex;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;

        width: 90%;
        padding-right: 1.5vw;
        padding-left: 1.5vw;
        padding-top: 2.5vh;
        padding-bottom: 2.5vh;
        background: white;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        cursor: pointer;
    }

    .div_faceim {
        /*background: pink;*/
        display: flex;
        justify-content: center;
        flex-basis: 0;
        flex-grow: 1;
    }

    .im_face {
        /*background: red;*/
        display: flex;
        width: 3vh;
        height: 3vh;
        -webkit-filter: brightness(150%);
        filter: brightness(150%);
    }

    .div_facetx {
        /*background: brown;*/
        display: flex;
        justify-content: center;
        flex-grow: 1;
    }

    /* Comentarios */

    .div_joia2 {
        /*background-color: #0c5460;*/
        text-align: right;
        /*width: 80px;*/
        width: 14%;
        right: 0px;
        align-items: center;
        align-self: flex-start;
        position: relative;
        bottom: 0px;
        display: flex;
        justify-content: center;
    }

    .noScrollMenu {
        scrollbar-width: none;
        -ms-overflow-style: none;
    }
    .noScrollMenu::-webkit-scrollbar {
        width: 0px; /* For Chrome, Safari, and Opera */
        display: none;
    }
    .bar_cidades {
        display: flex;
        vertical-align: middle;
        /*background-color: red;*/
        /*padding-left: 1vw;*/
        align-items: center;
        justify-content: space-evenly;
        background-image: url('/static/imgs/ic_barra_idiomas_w.png');
        /*background-size: auto 100%;*/
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        /*width: 100%;*/
        width: 26vh;
        height: 3.5vh;
    }

    .tx_title_estab {
        font-size: 2.2vh;
        font-weight: bold;
        font-size: 18pt;
    }

    .tx_cats_estab {
        font-size: 2vh;
    }

    .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
    }

    .im_id {
        width: 4vh;
        height: 4vh;
    }

    .tx_title_guia{
        margin-left: 50px;
    }

    .tx_maisinfo {
        font-weight: bold; /* Negrito */
    }
    .tx_address span {
        font-weight: bold; /* Negrito */
    }
    .tx_address a {
        font-weight: bold; /* Negrito */
    }

    @media screen and (min-width: 1100px) and (max-width: 1399px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.5vh;
        }

        .im_id {
            width: 4vh;
            height: 4vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
        }
    
    }

    @media screen and (min-width: 1400px) and (max-width: 1549px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.5vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
        }


        .tx_login2 {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            height: 40px;
            width: 110px;
            background-color: #9c27b0; /* Ajuste conforme necessário */
            color: #fff; /* Ajuste conforme necessário */
            border: none; /* Ajuste conforme necessário */
            border-radius: 5px; /* Ajuste conforme necessário */
            cursor: pointer;
            padding: 0; /* Adicione se necessário para remover qualquer padding interno */
        }

    }


    @media screen and (min-width: 1550px) and (max-width: 1599px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.5vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
            margin-left: 8%;
        }




    }

    @media screen and (min-width: 1600px) and (max-width: 1900px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.5vh;
        }

        .im_id {
            width: 4vh;
            height: 4vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
            margin-left: 10%;
        }
    
    }

    @media screen and (min-width: 1901px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.6vh;
        }

        .im_id {
            width: 4vh;
            height: 4vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
            margin-left: 15%;
        }
    
    }

    .tx_login2 {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 40px;
        width: 110px;
        background-color: #9c27b0; /* Ajuste conforme necessário */
        color: #fff; /* Ajuste conforme necessário */
        border: none; /* Ajuste conforme necessário */
        border-radius: 5px; /* Ajuste conforme necessário */
        cursor: pointer;
        padding: 0; /* Adicione se necessário para remover qualquer padding interno */
    }

    @media screen and (max-height: 800px) {
    .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 76px; /* Ajuste conforme necessário */
    }

    .tx_login2 {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 35px;
        width: 110px;
        background-color: #9c27b0; /* Ajuste conforme necessário */
        color: #fff; /* Ajuste conforme necessário */
        border: none; /* Ajuste conforme necessário */
        border-radius: 5px; /* Ajuste conforme necessário */
        cursor: pointer;
        padding: 0; /* Adicione se necessário para remover qualquer padding interno */
    }
    }

    @media screen and (min-height: 950px) {
    .tx_login2 {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 40px;
        width: 110px;
        background-color: #9c27b0; /* Ajuste conforme necessário */
        color: #fff; /* Ajuste conforme necessário */
        border: none; /* Ajuste conforme necessário */
        border-radius: 5px; /* Ajuste conforme necessário */
        cursor: pointer;
        padding: 0; /* Adicione se necessário para remover qualquer padding interno */
    }

}
</style>


// WEBPACK FOOTER //
// src/components/Estabelecimento.vue